module.exports = __webpack_public_path__ + "img/overview_data_pic2.22eb771d.png";